<template>
  <div class="container-fluid main-menu" id="acm-nav-menu">
    <div class="row">
      <div class="col-xl-2">
        <div class="form-group mt-2">
          <input name="nav_quick_find"
                 type="text"
                 class="form-control menu-search-input"
                 placeholder="Quick Find..."
                 v-model="searchQuery"
                 ref="nav_quick_find"
                 id="nav_quick_find"
                 @focus="$event.target.select()"
          >
        </div>
        <ul v-if="searchQuery === ''" class="nav nav-pills flex-column" role="tablist">
          <li role="presentation" class="nav-item">
            <a id="monitoring-tab" class="nav-link mainmenu-nav-pill" href="#menu-monitoring"
               aria-controls="menu-monitoring" aria-selected="true" role="tab" data-toggle="tab">
              <fa-icon icon="map-marker" fixed-width/>&nbsp;&nbsp;Monitoring
            </a>
          </li>
          <li v-if="security.canViewAssets()" role="presentation" class="nav-item">
            <a id="assets-tab" class="nav-link mainmenu-nav-pill" href="#menu-assets"
               aria-controls="menu-assets" aria-selected="true" role="tab" data-toggle="tab">
              <fa-icon icon="car" fixed-width/>&nbsp;&nbsp;Asset Management
            </a>
          </li>
          <li v-if="security.canViewTrackingUnits()" role="presentation" class="nav-item">
            <a id="tracking-units-tab" class="nav-link mainmenu-nav-pill" href="#menu-units"
               aria-controls="menu-units" aria-selected="false" role="tab"
               data-toggle="tab">
              <fa-icon icon="hdd" fixed-width/>&nbsp;&nbsp;Unit Management</a>
          </li>
          <li v-if="security.canViewAssets()" role="presentation" class="nav-item">
            <a id="reports-tab" class="nav-link mainmenu-nav-pill" href="#menu-reports"
               aria-controls="menu-reports" aria-selected="true" role="tab" data-toggle="tab">
              <fa-icon icon="file-chart-line" fixed-width/>&nbsp;&nbsp;Reports
            </a>
          </li>
          <li v-if="security.canViewAdministration()" role="presentation" class="nav-item">
            <a id="administration-tab" class="nav-link mainmenu-nav-pill" href="#menu-administration"
               aria-controls="menu-administration" aria-selected="false" role="tab"
               data-toggle="tab">
              <fa-icon icon="unlock-alt" fixed-width/>&nbsp;&nbsp;Administration</a>
          </li>
          <li role="presentation" class="nav-item">
            <a id="my-account-tab" class="nav-link mainmenu-nav-pill" href="#menu-my-account"
               aria-controls="menu-my-account" aria-selected="false" role="tab" data-toggle="tab">
              <fa-icon icon="user-circle" fixed-width/>&nbsp;&nbsp;My Account</a>
          </li>
        </ul>
      </div>
      <div class="col-xl-10">
        <div v-if="searchQuery === ''" class="tab-content">
          <ws-nav-menu-monitoring />
          <ws-nav-menu-assets v-if="security.canViewAssets()" />
          <ws-nav-menu-tracking-units v-if="security.canViewTrackingUnits()" />
          <ws-nav-menu-reports v-if="security.canViewAssets()" />
          <ws-nav-menu-administration v-if="security.canViewAdministration()" />
          <ws-nav-menu-my-account />
        </div>
        <div v-else>
          <div class="row mt-2">
            <div class="col">
              <h5>Menu item's containing "{{ searchQuery }}"</h5>
            </div>
          </div>
          <div v-if="filteredMenuItems.length > 0" class="row mt-2">
            <div v-for="(menuItem, index) in filteredMenuItems" :key="index" class="col-md-6 col-xl-3">
              <router-link tag="div"
                           class="submenu-nav-item"
                           active-class="active"
                           :to="menuItem.routerTo"
                           @click.native="menuState = !menuState">
                <div class="submenu-nav-icon">
                  <fa-icon :icon="menuItem.icon" :class="menuItem.iconClass + ' fa-3x'"/>
                </div>
                <div class="submenu-nav-content">
                  <p class="submenu-nav-item-title">{{ menuItem.title }}</p>
                  <p class="submenu-nav-item-details">{{ menuItem.details }}</p>
                </div>
              </router-link>
            </div>
          </div>
          <div v-else class="row">
            <div class="col">
              <h5 class="text-warning">No menu item's found matching your search query.</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3"></div>
    <div class="border border-secondary menu-bottom"></div>
  </div>
</template>

<script>
import WsNavMenuMonitoring from './NavMenuMonitoring'
import WsNavMenuAssets from './NavMenuAssets'
import WsNavMenuReports from './NavMenuReports'
import WsNavMenuAdministration from './NavMenuAdministration'
import WsNavMenuTrackingUnits from './NavMenuTrackingUnits'
import WsNavMenuMyAccount from './NavMenuMyAccount'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN,
  NAV_GET_SEARCH_QUERY,
  NAV_SET_SEARCH_QUERY,
  NAV_GET_FILTERED_MENU_ITEMS
} from '@/store/navigation/nav.types'

export default {
  computed: {
    menuState: {
      get () {
        return this.$store.getters[NAV_GET_MENU_OPEN]
      },

      set (value) {
        this.$store.commit(NAV_SET_MENU_OPEN, value)
      }
    },

    searchQuery: {
      get () {
        return this.$store.getters[NAV_GET_SEARCH_QUERY]
      },

      set (value) {
        this.$store.commit(NAV_SET_SEARCH_QUERY, value.trim())
      }
    },

    filteredMenuItems () {
      return this.$store.getters[NAV_GET_FILTERED_MENU_ITEMS]
    }
  },

  components: {
    WsNavMenuMonitoring,
    WsNavMenuAssets,
    WsNavMenuReports,
    WsNavMenuAdministration,
    WsNavMenuTrackingUnits,
    WsNavMenuMyAccount
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenu.vue